// Canonical profession display text: "Trade, specialty - contractor".

import type { TFunction } from 'i18next';
import { humanizeCamelCase, tradeLabel } from './tradeLabel';

export interface IProfessionDisplayParts {
  tradeId?: string | null;
  specialty?: string | null;
  contractor?: string | null;
}

export function professionDisplayText(t: TFunction, p: IProfessionDisplayParts): string {
  let label = p.tradeId ? tradeLabel(t, p.tradeId) : '';
  if (p.specialty) label += `, ${p.specialty}`;
  if (p.contractor) label += ` - ${p.contractor}`;
  return label;
}

// Trade-group header label: i18n entry with a humanised fallback
export function tradeGroupLabel(t: TFunction, tradeGroup: string): string {
  return t(`trades.${tradeGroup}`, { defaultValue: humanizeCamelCase(tradeGroup) });
}